import { createStylesParams, StyleParamType } from '@wix/tpa-settings';

export type LayoutStylesParams = {
  sectionImageHeight: StyleParamType.Number;
  headerImageHeight: StyleParamType.Number;
};

export const layoutStylesParams = createStylesParams<LayoutStylesParams>({
  sectionImageHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 320,
  },
  headerImageHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 320,
  },
});
